<script lang="ts" setup>
import { i18n } from '@/i18n';
import { TableContentProperty } from '../../interface/tableContentHeaders';
import TableHead from '../TableHead.vue';
import ArrowIcon from '../ArrowIcon.vue';
import { TrashBinTableContentViewModel } from './trashBinTableContentViewModel';
import { IYearMonth } from '@/coreDomainsModule/date';

const props = withDefaults(
  defineProps<{
    header: TableContentProperty;
    headerIndex: number;
    accumulationTableContentWidth: number;
    isVariableWidth: boolean;
    isAllSelected: boolean;
    stableColumnCount: number;
    forecastStartYearMonth?: IYearMonth;
  }>(),
  { forecastStartYearMonth: undefined }
);
const TrashBinTableContentVM = new TrashBinTableContentViewModel();

const emits = defineEmits<{
  (e: 'onClickSort', index: number, key: TableContentProperty, isAsc: boolean): void;
  (e: 'onMousedownResizer', event: MouseEvent, headerIndex: number): void;
  (e: 'onCheckboxSelected', displayId: string, isAllSelected: boolean): void;
}>();

const t = i18n.t;
</script>

<template>
  <TableHead
    :class="[TrashBinTableContentVM.isSticky(stableColumnCount, headerIndex) ? 'sticky-content' : '']"
    :style="{
      left: TrashBinTableContentVM.calcStickyDiff(stableColumnCount, headerIndex, accumulationTableContentWidth),
    }"
    :index="headerIndex"
    :resizable="
      // 幅可変な列 && 固定する列に含まれていない -> 可変幅
      header.isVariableWidth && !TrashBinTableContentVM.isSticky(stableColumnCount, headerIndex)
    "
    @on-mousedown-resizer="($event) => emits('onMousedownResizer', $event, headerIndex)"
  >
    <template v-if="header.key === 'trashBinChoice'">
      <RowCheckBox :is-checked="isAllSelected" class="md-primary all-check-button" @change-status="$emit('onCheckboxSelected', '', true)" />
    </template>
    <template v-else-if="header.sortOption.isSortable">
      <div class="table-header__sortable-content">
        <div class="table-header__text">{{ t(TrashBinTableContentVM.getHeaderText(header.key, forecastStartYearMonth) ?? '') }}</div>
        <ArrowIcon :asc="header.sortOption.isAsc" @on-click="emits('onClickSort', headerIndex, header, header.sortOption.isAsc)" />
      </div>
    </template>
    <template v-else>
      <div class="table-header__text">{{ t(TrashBinTableContentVM.getHeaderText(header.key, forecastStartYearMonth) ?? '') }}</div>
    </template>
  </TableHead>
</template>

<style scoped lang="scss"></style>
